// @mui
// icons
import emailIcon from '@iconify/icons-carbon/email';
import phoneIcon from '@iconify/icons-carbon/phone';
import { Box, Card, Divider, Link, Stack, Typography } from '@mui/material';
import { EmployeeProps } from 'src/@types/employee';
import Image from 'src/components/NextSanityImage';
// components
import { BgOverlay, Iconify } from '../../components';

// ----------------------------------------------------------------------

type Props = {
  member: EmployeeProps;
};

export default function TeamMember({ member }: Props) {
  const { name, position, profile, phone, email } = member;

  return (
    <Card>
      <Box sx={{ position: 'relative' }}>
        <BgOverlay
          sx={{
            opacity: 0,
            transition: (theme) =>
              theme.transitions.create('opacity', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.short,
              }),
            '&:hover': { opacity: 0.5 },
          }}
        >
          <Box
            sx={{
              width: 1,
              zIndex: 9,
              bottom: 24,
              display: 'flex',
              position: 'absolute',
              justifyContent: 'center',
            }}
          >
            {/* <SocialsButton color="primary" links={socialLinks} /> */}
          </Box>
        </BgOverlay>

        {profile && <Image src={profile} alt={name} ratio="1/1" />}
        <Shape />
      </Box>
      <Stack spacing={1.5} sx={{ textAlign: 'center', pt: 3, pb: 1.5 }}>
        <div>
          <Typography variant="h6" gutterBottom>
            {name}
          </Typography>
          <Typography variant="body3" sx={{ color: 'text.disabled' }}>
            {position}
          </Typography>
        </div>
        <Divider />
        <Stack spacing={1.5}>
          <Stack spacing={1} direction="row" alignItems="center" justifyContent="center">
            <Iconify icon={phoneIcon} sx={{ width: 18, height: 18, color: 'text.disabled' }} />
            <Link href={'tel:' + phone} color="inherit" underline="none" variant="body3">
              {phone}
            </Link>
          </Stack>
          <Stack spacing={1} direction="row" alignItems="center" justifyContent="center">
            <Iconify icon={emailIcon} sx={{ width: 18, height: 18, color: 'text.disabled' }} />
            <Link href={'mailto:' + email} color="inherit" underline="none" variant="body3">
              {email}
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}

// ----------------------------------------------------------------------

function Shape() {
  return (
    <Box
      sx={{
        bottom: 0,
        width: 1,
        height: 31,
        zIndex: 9,
        position: 'absolute',
        color: 'background.paper',
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="1080" height="32" viewBox="0 0 1080 32">
        <path fill="currentColor" d="M1080 32 L0 32L1080 0v32z" />
      </svg>
    </Box>
  );
}
